export const SET_LOADING_STATE = 'SET_LOADING_STATE'
export const SET_DASHBOARD_DATA = 'SET_DASHBOARD_DATA'
